import React, { useState } from "react";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  Grid,
  TextField,
  Divider
} from "@mui/material";

const steps = ["Personal Details", "Address Details", "Review & Submit"];

export default function StepperForm() {
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({ name: "", email: "", address: "" });

  const handleNext = () => setActiveStep((prevStep) => prevStep + 1);
  const handleBack = () => setActiveStep((prevStep) => prevStep - 1);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <>
            <TextField label="Name" name="name" fullWidth margin="normal" onChange={handleChange} />
            <TextField label="Email" name="email" fullWidth margin="normal" onChange={handleChange} />
          </>
        );
      case 1:
        return <TextField label="Address" name="address" fullWidth margin="normal" onChange={handleChange} />;
      case 2:
        return (
          <>
            <Typography>Name: {formData.name}</Typography>
            <Typography>Email: {formData.email}</Typography>
            <Typography>Address: {formData.address}</Typography>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <Box sx={{ width: "70%", margin: "auto", textAlign: "center", mt: 4 }}>
      <img src="/logo.png" alt="Logo" style={{ maxWidth: 150, marginBottom: 20 }} />
      <Divider sx={{ mb: 2, borderBottomWidth: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <Box>{renderStepContent(activeStep)}</Box>
          <Box sx={{ mt: 2 }}>
            <Button disabled={activeStep === 0} onClick={handleBack} sx={{ mr: 1 }}>
              Back
            </Button>
            <Button variant="contained" onClick={handleNext}>
              {activeStep === steps.length - 1 ? "Submit" : "Next"}
            </Button>
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Stepper activeStep={activeStep} orientation="vertical" sx={{ borderLeft: "2px solid #ddd", paddingLeft: 2 }}>
            {steps.map((label, index) => (
              <Step key={index}>
                <StepLabel
                  StepIconProps={{
                    sx: { fontSize: "1.5rem", color: activeStep >= index ? "#4caf50" : "gray" },
                  }}
                >
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Grid>
      </Grid>
    </Box>
  );
}